import usePageTitle from "@/hooks/usePageTitle";
import FocusedPageLayout from "@/layouts/FocusedPageLayout";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { InteractionDetails } from "@/components/interactions";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useBackNavigation } from "@/hooks/useBackNavigation";

export default function InteractionShowPage() {
  usePageTitle(
    "/people/:pgaId/interactions/interactions/:interactionId",
    "People | Person Details | Interactions | Interaction Details"
  );
  const [actions, setActions] = useState<React.ReactNode>(null);
  const { onBackClick, backLink } = useBackNavigation();

  const { pgaId, interactionId } = useParams();

  // Note: Interaction data may be passed via route state from the parent interactions list
  // to avoid making redundant queries. See InteractionDetails component for implementation.

  if (!pgaId || !interactionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Missing required parameters" />
      </div>
    );
  }

  return (
    <FocusedPageLayout backLink={backLink} onBackClick={onBackClick} actions={actions} stickyActions>
      <InteractionDetails
        pageContext="Person"
        interactionId={interactionId}
        pgaId={pgaId}
        setActions={setActions}
        onBack={onBackClick}
      />
    </FocusedPageLayout>
  );
}
